import {
  FollowUpStatus,
  VoicemailFollowUpFilterInput,
} from '@api/generated/graphql';
import { UrgentFollowUpTabs } from '@pages/urgentfollowups/types';
import { sevenDaysInMS } from '@pages/urgentfollowups/utils/filters';
import { VoicemailsFilters } from '@pages/urgentfollowups/VoicemailsPage/types';

const openFollowUpStatuses = [
  FollowUpStatus.New,
  FollowUpStatus.FollowUpNeeded,
  FollowUpStatus.ContactAttempted,
];

const coldFollowUpStatuses = [...openFollowUpStatuses];

export const doneFollowUpStatuses = [
  FollowUpStatus.Dismissed,
  FollowUpStatus.Resolved,
];

export const getVoicemailsBadgeCountFilters =
  (): VoicemailFollowUpFilterInput => {
    const fromDate = getOpenVoicemailFilters().fromDate;
    fromDate?.setMilliseconds(0);
    fromDate?.setSeconds(0);

    return {
      fromDate,
      followUpStatuses: [FollowUpStatus.New],
    };
  };

export const getStatusFilters = (tab: UrgentFollowUpTabs): FollowUpStatus[] => {
  switch (tab) {
    case UrgentFollowUpTabs.Open:
      return openFollowUpStatuses;
    case UrgentFollowUpTabs.Cold:
      return coldFollowUpStatuses;
    case UrgentFollowUpTabs.Done:
      return doneFollowUpStatuses;
  }
};

const getOpenVoicemailFilters = (): Partial<VoicemailsFilters> => {
  return {
    fromDate: new Date(new Date().getTime() - sevenDaysInMS),
  };
};

const getColdVoicemailFilters = (): Partial<VoicemailsFilters> => {
  return {
    toDate: new Date(new Date().getTime() - sevenDaysInMS),
  };
};

const getDoneVoicemailFilters = (): Partial<VoicemailsFilters> => {
  return {};
};

export const getDefaultVoicemailFilters = (
  tab: UrgentFollowUpTabs,
): VoicemailsFilters => {
  const statuses = getStatusFilters(tab);
  const filter: VoicemailsFilters = {
    statuses,
    includeNullCampaigns: false,
  };

  switch (tab) {
    case UrgentFollowUpTabs.Open:
      return { ...filter, ...getOpenVoicemailFilters() };
    case UrgentFollowUpTabs.Cold:
      return { ...filter, ...getColdVoicemailFilters() };
    case UrgentFollowUpTabs.Done:
      return { ...filter, ...getDoneVoicemailFilters() };
  }
};
